import { defineComponent as _defineComponent } from 'vue'

import { useLightbox } from "@/services/lightbox";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageGallery',
  props: {
    sources: null
  },
  setup(__props: any) {

const props = __props as {
  sources: string[];
}



const { showGallery } = useLightbox();

function handleImageClick(index: number) {
  showGallery(props.sources, index);
}

return { __sfc: true,props, showGallery, handleImageClick }
}

})